<template>
  <div class="skeleton-followers-by-channel">
    <v-skeleton-loader
      type="text"
      class="skeleton-followers-by-channel__title"
    />

    <div class="skeleton-followers-by-channel__chart">
      <v-skeleton-loader
        type="avatar"
      />
      <div class="skeleton-followers-by-channel__label">
        <v-skeleton-loader
          type="text"
        />
        <v-skeleton-loader
          type="text"
        />
      </div>
    </div>

    <div class="skeleton-followers-by-channel__legends">
      <v-skeleton-loader
        type="text"
      />
      <v-skeleton-loader
        type="text"
      />
      <v-skeleton-loader
        type="text"
      />
      <v-skeleton-loader
        type="text"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonFollowersByChannel',
};
</script>

<style scoped lang="scss">
.skeleton-followers-by-channel {
  display: block;
  border: 1px solid var(--ds-color-silver);
  padding: 20px;
  border-radius: 6px;
  min-height: 325px;

  &__chart {
    display: grid;
    grid-template-columns: 104px 1fr;
    gap: 18px;
    align-items: center;
    margin-top: var(--ds-spacing-stack-sm);
    margin-bottom: var(--ds-spacing-stack-sm);
  }

  &__legends {
    max-width: 169px;
  }
}

::v-deep {
  .v-skeleton-loader__text {
    margin-bottom: 0;
    background: linear-gradient(90deg, rgba(245, 245, 245, 1) 0%, rgba(210, 210, 212, 1) 80%) !important;
  }

  .v-skeleton-loader__avatar {
    position: relative;
    width: 104px;
    height: 104px;
    background: linear-gradient(90deg, rgba(245, 245, 245, 1) 0%, rgba(210, 210, 212, 1) 80%) !important;

    &::before {
      content: '';
      display: block;
      width: 65px;
      height: 65px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      border-radius: 50%;
      background: var(--ds-color-white-text);
    }
  }

  .skeleton-followers-by-channel {
    &__title .v-skeleton-loader__text {
      border-radius: var(--ds-spacing-stack-sm);
      height: var(--ds-spacing-stack-sm);
    }

    &__legends .v-skeleton-loader__text {
      border-radius: var(--ds-border-radius-pill);
      height: var(--ds-spacing-stack-xs);
    }

    &__label > div .v-skeleton-loader__text {
      border-radius: var(--ds-border-radius-pill);
      height: var(--ds-spacing-stack-xs);
    }

    &__label > div:first-child {
      margin-bottom: var(--ds-spacing-stack-nano);

      .v-skeleton-loader__text {
        height: var(--ds-spacing-stack-sm);
      }
    }

    &__legends > div:not(:last-child) {
      margin-bottom: var(--ds-spacing-stack-nano);
    }
  }

  .theme--light.v-skeleton-loader .v-skeleton-loader__bone::after {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0));
  }
}
</style>
